import Pagination from "components/Pagination";
import { DisputedBracket } from "core/models/Bracket";
import { getDate } from "core/utils/Date";

interface BracketDisputeTableProps {
  disputes: DisputedBracket[];
  count: number;
  currentPage: number;
  onPageChange: (pageNumber: number) => void;
  handleDisputeClick: (seed: DisputedBracket) => void;
}

export default function BracketDisputeTable({
  disputes,
  count,
  currentPage,
  onPageChange,
  handleDisputeClick,
}: BracketDisputeTableProps) {
  if (!disputes || disputes.length === 0) {
    return <div className="no-data">No dispute available</div>;
  }

  return (
    <>
      <div className="bracket-dispute-table-wrapper">
        <div className="grid-row">
          <span className="heading">Match No</span>
          <span className="heading">Teams</span>
          <span className="heading">Raised By</span>
          <span className="heading">Raised On</span>
          <span className="heading">Status</span>
          <span className="heading">Action</span>
        </div>

        {disputes.map((dispute, index) => {
          const status = dispute.approvalStatus;

          return (
            <div className="grid-row bracket-head" key={index}>
              <span className="heading">{dispute?.matchNumber}</span>

              <span className="heading">
                {dispute?.teams?.map((team) => team?.name).join(" vs ") || "-"}
              </span>

              <span className="heading">
                {
                  dispute?.teams?.find(
                    (team) => team?.id === dispute?.approvalTeamId
                  )?.name
                }
              </span>

              <span className="heading">
                {" "}
                {getDate(dispute?.dispute?.raisedOn, "MMM DD, YYYY hh:mm")}
              </span>

              {/* STATUS BADGE */}
              <span className="heading">
                <span className={`status-badge ${status?.toLowerCase()}`}>
                  {status}
                </span>
              </span>

              <span
                className="heading"
                onClick={(e) => {
                  handleDisputeClick(dispute);
                }}
              >
                <span className="view">View</span>
              </span>
            </div>
          );
        })}
      </div>

      {count > 1 && (
        <div className="pagination">
          <Pagination
            pages={Math.ceil(count / 8)}
            limit={10}
            activePage={currentPage + 1}
            maxButtons={6}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </>
  );
}
